import {Component, inject, Input, OnChanges} from '@angular/core';
import {MetaTypes} from '../../core/definitions/meta-types';
import {SettingsService} from '../../core/settings.service';
import {ClientConfig} from "../../core/definitions/client-config";

@Component({
    selector: 'app-overview-title',
    templateUrl: './overview-title.component.html',
    styleUrls: ['./overview-title.component.scss'],
    standalone: false
})
export class OverviewTitleComponent implements OnChanges {
  // Injections
  private readonly settingsService: SettingsService = inject(SettingsService);

  @Input() objectView: any;
  @Input() noTitle: boolean;
  @Input() smallTit: boolean;
  @Input() titleAsLink: boolean;

  MetaTypes = MetaTypes;
  title: string;
  clientConfig: ClientConfig;

  ngOnChanges() {
    this.clientConfig = this.settingsService.getClientConfig();
    this.title = '';
    if (this.objectView.artifact_name && !this.noTitle) {
      this.title = this.objectView.artifact_name.replace('<del>', '').replace('</del>', '');
    }
  }

}
